if (!customElements.get('accessibility-tablist')) {
    class AccessibilityTablist extends HTMLElement {
        constructor() {
            super();
            this.buttonsSelector = this.dataset.buttonsSelector || "button[role='tab']";
            this.buttons = [];
        }

        connectedCallback() {
            this.buttons = Array.from(this.querySelectorAll(this.buttonsSelector));
            this.registerEventListeners();
        }

        registerEventListeners() {
            const total = this.buttons.length;
            this.buttons.forEach((button, index) => {
                if (button.dataset.tablistBound === 'true') {
                    return;
                }

                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.dispatchActivation(button, index);
                });

                button.addEventListener('keydown', (event) => {
                    let nextIndex = index;
                    switch (event.key) {
                        case 'ArrowRight':
                        case 'ArrowDown':
                            event.preventDefault();
                            nextIndex = (index + 1) % total;
                            this.buttons[nextIndex].focus();
                            this.dispatchActivation(this.buttons[nextIndex], nextIndex);
                            break;
                        case 'ArrowLeft':
                        case 'ArrowUp':
                            event.preventDefault();
                            nextIndex = (index - 1 + total) % total;
                            this.buttons[nextIndex].focus();
                            this.dispatchActivation(this.buttons[nextIndex], nextIndex);
                            break;
                        case 'Home':
                            event.preventDefault();
                            this.buttons[0].focus();
                            this.dispatchActivation(this.buttons[0], 0);
                            break;
                        case 'End':
                            event.preventDefault();
                            const lastIndex = total - 1;
                            this.buttons[lastIndex].focus();
                            this.dispatchActivation(this.buttons[lastIndex], lastIndex);
                            break;
                        default:
                            break;
                    }
                });

                button.dataset.tablistBound = 'true';
            });
        }

        dispatchActivation(button, index) {
            this.dispatchEvent(new CustomEvent('tablist:activate', {
                bubbles: true,
                detail: {
                    button,
                    index
                }
            }));
        }
    }

    customElements.define('accessibility-tablist', AccessibilityTablist);
}
